import React, { useState } from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styled from 'styled-components';
import union20 from '../../Assets/union20.png';

const StyledModal = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalContent = styled(Box)`
    background: white;
    padding: 0;
    border-radius: 10px;
    position: relative;
    text-align: center;
    max-width: 440px;
    width: 100%;
`;

const CloseButton = styled(IconButton)`
    position: absolute;
    top: -205px;
    right: -175px;
    color: black !important;
    font-size: 20px;
    z-index: 3; 
`;

const ImageContainer = styled.div`
    width: 100%;
    height: 200px;
    overflow: hidden;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    position: relative; 
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

const Line = styled.div`
    height: 5px; 
    background-color: rgb(168, 0, 0); 
    width: 100%;
    margin-top:-1px;
`;

const Content = styled.div`
    padding: 20px;
`;

const MessageError = ({ err }) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <StyledModal open={open} onClose={handleClose}>
            <ModalContent>
                <ImageContainer>
                    <img src={union20} alt="Bulls" />
                    <CloseButton onClick={handleClose}>
                        <CloseIcon />
                    </CloseButton>
                </ImageContainer>
                <Line />
                <Content>
                    <Typography variant="h6" component="h2" sx={{ fontWeight: "700" }}>
                        Upsss!
                    </Typography>
                    <Typography variant="body1" component="p" sx={{ marginTop: 5, fontWeight: "600", fontSize: "14px" }}>
                        Connection problems, please try again.
                        If the problem persists, please contact the site administrator.
                    </Typography>
                    <Typography variant="body2" component="p" sx={{ marginTop: 8, fontSize: "12px" }}>
                        <a href="/" onClick={(e) => {
                            e.preventDefault();
                            window.location.reload();
                        }}>
                            Reload
                        </a>
                    </Typography>
                </Content>
            </ModalContent>
        </StyledModal>
    );
};

export default MessageError;
